/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * @param {{ date: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const explain_sealed_body = (params) => `Je ticket wordt pas kort voor het evenement zichtbaar — vanaf ${params.date}. Dat is bewust: een ticket dat nog niet bestaat, kan ook niet nagemaakt of buiten ons om doorverkocht worden.`
